<template>
  <div>
    <div
      id="signingModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fontSize20">請款單-電子簽單列表</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <table class="table table-striped jambo_table bulk_action">
                <thead>
                  <tr class="headings fontSize16">
                    <th class="column-title">產生日期</th>
                    <th class="column-title">上車地點</th>
                    <th class="column-title">下車地點</th>
                    <th class="column-title">乘客名稱</th>
                    <th class="column-title">簽單備註</th>
                    <th class="column-title">乘客備註</th>
                    <th class="column-title">客服備註</th>
                    <th class="column-title">實際金額</th>
                    <th class="column-title">服務費用</th>
                    <th class="column-title">放入領款單</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(signing, index) in signingList">
                    <tr
                      class="pointer fontSize16"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <td class=" ">
                        {{
                          signing.replenishmentAt === undefined
                            ? signing.createdAt
                            : signing.replenishmentAt
                        }}
                      </td>
                      <td class=" ">{{ signing.onAddress }}</td>
                      <td class=" ">{{ signing.offAddress }}</td>
                      <td class=" ">{{ signing.employeeName }}</td>
                      <td class=" ">{{ signing.signingNote }}</td>
                      <td class=" ">{{ signing.passengerNote }}</td>
                      <td class=" ">{{ signing.serviceNote }}</td>
                      <td class=" ">{{ signing.actualFare }}</td>
                      <td class=" ">{{ signing.serviceFee }}</td>
                      <td class="">
                        <input
                          type="checkbox"
                          class="flat"
                          style="zoom: 180%"
                          v-model="signingList[index].isPayment"
                          :disabled="signing.isOptInvocie"
                          @click="selectSigningOfInvoice(index)"
                        />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="addSigningToWithdrawal"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['optSigningDetailList', 'task'],
  data() {
    return {
      signingList: [],
      signing: [],
      removeFromWithdrawal: [],
      addFromWithdrawal: [],
      invoiceId: null,
    }
  },
  methods: {
    initialInfo() {
      if (this.optSigningDetailList.length === 0) return
      const map1 = this.optSigningDetailList
        .map((item) => item.invoiceId)
        .indexOf(this.invoiceId)
      if (map1 === -1) return
      for (
        let i = 0;
        i < this.optSigningDetailList[map1].optionSignintList.length;
        i++
      ) {
        const checkSigningList = this.signingList
          .map((item) => item.id)
          .indexOf(this.optSigningDetailList[map1].optionSignintList[i].id)
        if (checkSigningList !== -1) {
          this.signingList[checkSigningList].isPayment = true
          this.addFromWithdrawal.push(
            this.optSigningDetailList[map1].optionSignintList[i].id,
          )
        }
      }
    },
    showModal(id, signingList, optSigningAndInvoice) {
      this.addFromWithdrawal = []
      this.signingList = signingList
      this.invoiceId = id
      // 判別主List是否有資料
      if (optSigningAndInvoice.length !== 0) {
        let invoiceIndex = optSigningAndInvoice
          .map((element) => element.invoiceId)
          .indexOf(id)
        if (invoiceIndex !== -1) {
          let optionSigningList =
            optSigningAndInvoice[invoiceIndex].optionSignintList
          if (optionSigningList.length === 0) {
            for (let i = 0; i < this.signingList.length; i++) {
              this.signingList[i].isPayment = true
              this.signingList[i].isOptInvocie = true
              this.addFromWithdrawal.push(signingList[i].id)
            }
          } else {
            for (let j = 0; j < optionSigningList.length; j++) {
              let index = signingList
                .map((element) => element.id)
                .indexOf(optionSigningList[j].id)
              if (index !== -1)
                this.signingList[index].isPayment =
                  optionSigningList[j].isPayment
            }
            for (let i = 0; i < this.signingList.length; i++) {
              this.signingList[i].isOptInvocie = false
              if (this.signingList[i].isPayment)
                this.addFromWithdrawal.push(signingList[i].id)
            }
          }
        }
      }
      this.initialInfo()
      $('#signingModal').modal('show')
    },
    selectSigningOfInvoice(index) {
      // 使用者選擇單一簽單
      this.signingList[index].isPayment = !this.signingList[index].isPayment
      this.operateArray(
        this.signingList[index].isPayment,
        this.removeFromWithdrawal,
        this.addFromWithdrawal,
        this.signingList[index].id,
      )
    },
    operateArray(isSelect, nonTickArray, tickArray, id) {
      if (isSelect) {
        // 加array, 移nonArray
        this.removeArrayElement(nonTickArray, id)
        this.addElementToArray(tickArray, id)
      } else {
        // 移除array, nonArray
        this.removeArrayElement(nonTickArray, id)
        this.removeArrayElement(tickArray, id)
      }
    },
    addElementToArray(array, id) {
      if (array.indexOf(id) === -1) {
        array.push(id)
      }
    },
    removeArrayElement(array, id) {
      if (array.indexOf(id) !== -1) {
        array.splice(array.indexOf(id), 1)
      }
    },
    addSigningToWithdrawal() {
      let optionArray = []
      console.log('addFromWithdrawal', this.addFromWithdrawal)
      for (let i = 0; i < this.addFromWithdrawal.length; i++) {
        const map1 = this.signingList
          .map((item) => item.id)
          .indexOf(this.addFromWithdrawal[i])
        optionArray.push(this.signingList[map1])
      }
      let value = {
        invoiceId: this.invoiceId,
        optionSignintList: optionArray,
      }
      console.log('addSigningToWithdrawal', value)
      this.$emit('optSigningList', value)
      $('#signingModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/company/SigningListInWithdrawalModal.vue